/**
 * Created by ddodson on 1/15/16.
 */
const L = require('./vendor/leaflet');
const Surging = require('./surging').default;

Surging.Control.MapControl = Surging.Control.extend({

  setWaterLevel: function(level) {
    const ss2Unit = level.unit === "m" ? "meters" : level.unit;
    this._map.options.composer.unit(ss2Unit);
    this._map.options.composer.level(level.level.toString());
    this._map.setWaterUnit(ss2Unit, false);
    this._map.setWaterLevel(level.level.toString(), false);
  },

  onAdd: function(map) {
    map.dragging.disable();
    map.touchZoom.disable();
    map.doubleClickZoom.disable();
    map.scrollWheelZoom.disable();
    map.keyboard.disable();

    this._map = map;

    return L.DomUtil.create("div", "waterslider-dummy-control");
  }

});
